/**
 * @generated SignedSource<<2ff2d0d3d04d49fc3920ad249814d9b8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type mention_AtlassianSearchPage_UserMention$data = {
  readonly entity: {
    readonly associatedWith?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entity: {
            readonly email?: string | null;
            readonly extendedProfile?: {
              readonly jobTitle: string | null;
            } | null;
            readonly externalId?: string;
            readonly name?: string | null;
            readonly nickname?: string | null;
            readonly picture?: AGG$URL | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly externalId?: string | null;
  } | null;
  readonly " $fragmentType": "mention_AtlassianSearchPage_UserMention";
};
export type mention_AtlassianSearchPage_UserMention$key = {
  readonly " $data"?: mention_AtlassianSearchPage_UserMention$data;
  readonly " $fragmentSpreads": FragmentRefs<"mention_AtlassianSearchPage_UserMention">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "externalId"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "mention_AtlassianSearchPage_UserMention",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "concreteType": "ExternalAssociationConnection",
              "kind": "LinkedField",
              "name": "associatedWith",
              "plural": false,
              "selections": [
                {
                  "concreteType": "ExternalAssociationEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "ExternalAssociation",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "entity",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "kind": "ScalarField",
                                  "name": "name"
                                },
                                {
                                  "kind": "ScalarField",
                                  "name": "nickname"
                                },
                                {
                                  "kind": "ScalarField",
                                  "name": "email"
                                },
                                {
                                  "kind": "ScalarField",
                                  "name": "picture"
                                },
                                {
                                  "concreteType": "ThirdPartyUserExtendedProfile",
                                  "kind": "LinkedField",
                                  "name": "extendedProfile",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "ScalarField",
                                      "name": "jobTitle"
                                    }
                                  ]
                                }
                              ],
                              "type": "ThirdPartyUser"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "type": "ExternalMessage"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "d8a4ea1cfe7d70e01deb31e9014eb37a";

export default node;
